import { type CredentialStore, validOnlineApiKey } from '../crypto/storage.js';
import { OnlineApiError } from './errors.js';

export type OnlineCredentialSource = 'environment' | 'saved' | 'none';

export interface ResolvedOnlineCredentials {
  apiKey?: string;
  source: OnlineCredentialSource;
  environmentConfigured: boolean;
  savedConfigured: boolean;
}

export function resolveOnlineCredentials(
  store: CredentialStore,
  environment: NodeJS.ProcessEnv = process.env,
): ResolvedOnlineCredentials {
  const environmentKey = environment.ZAPAROO_ONLINE_USER_API_KEY?.trim();
  const savedKey = store.getOnlineApiKey();
  if (environmentKey) {
    if (!validOnlineApiKey(environmentKey)) {
      throw new OnlineApiError(
        'ZAPAROO_ONLINE_USER_API_KEY must begin with zpk1_ and contain no whitespace',
        'authentication',
      );
    }
    return {
      apiKey: environmentKey,
      source: 'environment',
      environmentConfigured: true,
      savedConfigured: savedKey !== undefined,
    };
  }
  return {
    apiKey: savedKey,
    source: savedKey ? 'saved' : 'none',
    environmentConfigured: false,
    savedConfigured: savedKey !== undefined,
  };
}
